var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgMenuDotsHorizontalCircle = function SvgMenuDotsHorizontalCircle(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 5C8.24594 5 5 8.24594 5 12.25C5 16.2541 8.24594 19.5 12.25 19.5C16.2541 19.5 19.5 16.2541 19.5 12.25C19.5 8.24594 16.2541 5 12.25 5ZM3 12.25C3 7.14137 7.14137 3 12.25 3C17.3586 3 21.5 7.14137 21.5 12.25C21.5 17.3586 17.3586 21.5 12.25 21.5C7.14137 21.5 3 17.3586 3 12.25Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3998 13.35C9.00732 13.35 9.4998 12.8575 9.4998 12.25C9.4998 11.6425 9.00732 11.15 8.3998 11.15C7.79229 11.15 7.2998 11.6425 7.2998 12.25C7.2998 12.8575 7.79229 13.35 8.3998 13.35Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2499 13.3775C12.8574 13.3775 13.3499 12.885 13.3499 12.2775C13.3499 11.67 12.8574 11.1775 12.2499 11.1775C11.6424 11.1775 11.1499 11.67 11.1499 12.2775C11.1499 12.885 11.6424 13.3775 12.2499 13.3775Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1 13.35C16.7075 13.35 17.2 12.8575 17.2 12.25C17.2 11.6425 16.7075 11.15 16.1 11.15C15.4925 11.15 15 11.6425 15 12.25C15 12.8575 15.4925 13.35 16.1 13.35Z",
    fill: "black"
  })));
};
export { SvgMenuDotsHorizontalCircle as ReactComponent };
export default __webpack_public_path__ + "static/media/menu-dots-horizontal-circle.5a311920.svg";